export const ANCHOR_POINTS = [9, 29, 38, 49];
export const ANCHOR_POINTS_MAP = {
  VR2: [9, 29, 38, 49],
  VR3: [22, 31, 51, 13],
};
export const DISTANCE_DAMPER = 120;
export const TOTAL_IMAGES = 59;
